import React, { useState, useEffect, useContext, useRef } from 'react'
import { Button, Col, Divider, Drawer, Input, Row, Typography, message, Select } from 'antd'
import { useReactToPrint } from 'react-to-print'
import GenericSelect from '../../../components/GenericSelect'
import Utils from '../../../utils/Utils'
import PosSrc from '../PosSrc'
import PosModalDeposit from './PosModalDeposit'
import DBService from '../../../utils/DBService'
import { Context } from '../../../context'
import { TurnTicketFactura } from '../../shops/components/turns/TurnTicketFactura'

const { Option } = Select
const { Title } = Typography

function PosDrawer(props) {
  const [state, dispatch] = useContext(Context)
  const [shopsList, setShopsList] = useState([])
  const [storeTurnList, SetStoreTurnList] = useState([])
  const [selectedShop, setSelectedShop] = useState(null)
  const [storeTurn, SetStoreTurn] = useState(null)
  const [storeCash, setStoreCash] = useState(0)
  const [confirmClose, setConfirmClose] = useState(false)
  const [loading, setLoading] = useState(false)
  const [closeLoading, setCloseLoading] = useState(false)
  const [spentCash, setSpentCash] = useState(null)
  const [spentCashInfo, setSpentCashInfo] = useState('')
  const [sellByCard, setSellByCard] = useState(null)
  const [sellByeExternalServices, setSellByeExternalServices] = useState(null)
  const [storePos, setStorePos] = useState({})
  const [cashAvailable, setCashAvailable] = useState(null)
  const [openTurn, setOpenTurn] = useState(null)
  const [addDeposit, setAddDeposit] = useState(false)
  const [total, setTotal] = useState(0)
  const [flag, setFlag] = useState(false)
  const [storeTurnState, setStoreTurnState] = useState({})
  const [paymentMethods, setPaymentMethods] = useState([])
  const [sellByNewMethods, setSellByNewMethods] = useState([])
  const [sold, setSold] = useState([])

  useEffect(() => {
    if (state.turn.is_open) {
      setOpenTurn(state.turn)
    } else {
      fetchShops()
    }

    setSpentCash(null)
    setSpentCashInfo(null)
    setSellByCard(null)
    setSellByeExternalServices(null)
    setCashAvailable(null)
    setSellByNewMethods([])
    // eslint-disable-next-line
  }, [state.turn])

  useEffect(() => {
    SetStoreTurnList([])
    SetStoreTurn(null)
    let shop = shopsList.find(shop => shop.id === selectedShop)
    setStoreCash(shop?.petty_cash_amount || 0)
    fetchStoreTurns()

    // eslint-disable-next-line
  }, [selectedShop])

  // eslint-disable-next-line
  useEffect(() => { handlePrint() }, [total, flag])
  useEffect(() => { setPaymentMethods(props.paymentMethods) }, [props.paymentMethods])

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  },);

  const fetchShops = () => {
    setLoading(true)
    PosSrc.getAllStores()
      .then(response => {
        if (response) {
          setShopsList(response.data)
          setLoading(false)
        }
      })
      .catch(err => {
        console.log(err)
        message.error('Error al cargar tiendas')
        setLoading(false)
      })
  }

  const fetchStoreTurns = () => {
    PosSrc.getStoreTurns(selectedShop)
      .then(response => {
        if (response) {
          SetStoreTurnList(response.data)
        }
      })
      .catch(err => {
        console.log(err)
        message.error('Error al cargar tiendas')
        return false
      })
  }

  const onStart = status => {
    if (status) {
      if (selectedShop && storeTurn) {
        setCloseLoading(true)
        let data = {
          store_id: selectedShop,
          turn_id: storeTurn,
          open_petty_cash_amount: storeCash,
        }
        let store = shopsList.find(shop => shop.id === selectedShop)
        let turnInfo = storeTurnList.find(turn => turn.id === storeTurn)
        PosSrc.openStoreTurn(data)
          .then(response => {
            if (response.errors && Object.keys(response.errors).length > 0) {
              Object.keys(response.errors).forEach(key => {
                if (key === 'store_id') {
                  message.error(response.errors[key][0].replace('store_id', 'tienda'))
                } else {
                  message.error(response.errors[key])
                }
              })
            } else {
              DBService.deleteAll('turn')
              DBService.deleteAll('products')
              DBService.deleteAll('clients')
              DBService.deleteAll('paymentMethods')
              DBService.deleteAll('sells')
              DBService.deleteAll('combos')
              setOpenTurn(response)
              dispatch({
                type: 'TURN OPENED',
                payload: response,
              })
              dispatch({
                type: 'TURN STORE',
                payload: store,
              })
              dispatch({
                type: 'TURN INFO',
                payload: turnInfo,
              })
              let turn = [
                {
                  turn: response,
                  store,
                  turnInfo,
                },
              ]
              DBService.add(turn, 'turn')
              props.infoStore(store, turnInfo)
              props.status(status)
            }
            setCloseLoading(false)
          })
          .catch(err => {
            console.log(err)
            message.error('No se pudo iniciar el turno')
            return false
          })
      } else {
        message.warning('Todos los campos son necesarios')
      }
    } else {
      onFinish()
    }
  }

  const onFinish = async () => {
    let validate = false
    let isNan = false

    const sellByNewMethodsAux = sellByNewMethods.filter(value => Object.keys(value).length !== 0);

    const paymentMethodsAux = paymentMethods?.filter(data => data.company_id === props.companyId)

    if (sellByNewMethodsAux.length !== paymentMethodsAux.length) {
      isNan = true
    } else {
      sellByNewMethodsAux.forEach(element => {
        if (element.total_sold.trim().length === 0) {
          isNan = true
        }
      });
    }

    if ([spentCash, sellByCard, sellByeExternalServices, cashAvailable].includes('') || [spentCash, sellByCard, sellByeExternalServices, cashAvailable].includes(null)) {
      message.warning('Todos los campos son obligatorios')
    } else if ((!trunc(spentCash) && !(spentCash >= 0)) || spentCash.includes('-') || spentCash.includes('+')) {
      message.warning('El campo ¿Cuánto hubo en gastos en efectivo que no fueron compras? solo acepta valores numéricos')
    } else if ((!trunc(sellByCard) && !(sellByCard >= 0)) || sellByCard.includes('-') || sellByCard.includes('+')) {
      message.warning('El campo ¿Cuánto vendiste en tarjeta? solo acepta valores numéricos')
    } else if ((!trunc(sellByeExternalServices) && !(sellByeExternalServices >= 0)) || sellByeExternalServices.includes('-') || sellByeExternalServices.includes('+')) {
      message.warning('El campo ¿Cuánto vendiste en servicios externos? solo acepta valores numéricos')
    } else if ((!trunc(cashAvailable) && !(cashAvailable >= 0)) || cashAvailable.includes('-') || cashAvailable.includes('+')) {
      message.warning('El campo ¿Cuánto efectivo tienes en mano al cerrar el turno? solo acepta valores numéricos')
    } else if (isNan) {
      message.warning('Los campos metodos de pago propios de la empresa solo aceptan valores numericos')
    } else {
      validate = true
    }

    if (validate) {
      const sells = await DBService.getAll('sells')

      if (sells.length > 0) await saveOfflineSells(sells)

      setCloseLoading(true)

      setSellByNewMethods(sellByNewMethodsAux)

      let data = {
        expenses_in_not_purchases: spentCash,
        expenses_reason: spentCashInfo,
        card_sales: sellByCard,
        external_services_sales: sellByeExternalServices,
        cash_on_hand: cashAvailable,
        sold_other_payment_methods: sellByNewMethodsAux
      }

      PosSrc.closeStoreTurn(state.turn.id, data)
        .then(response => {
          if (!response) {
            message.error('No hay conexión a internet')
          } else {
            const { sold_with_other_payment_methods } = response
            setSold(sold_with_other_payment_methods)

            Promise.all([
              DBService.deleteAll('turn'),
              DBService.deleteAll('products'),
              DBService.deleteAll('clients'),
              DBService.deleteAll('paymentMethods'),
              DBService.deleteAll('sells'),
              DBService.deleteAll('combos'),
            ]).then(() => {
              setConfirmClose(true)
              setCloseLoading(false)
              message.success('El turno se ha cerrado correctamente')
              setStorePos(response)
            })
          }
        })
        .catch(err => {
          console.log(err)
          message.error('No se pudo cerrar el turno')
          return false
        })
    }
  }

  const saveOfflineSells = async data => {
    let _data = {
      store_id: data[0].store_id,
      sells: data.map(d => ({
        seller_id: state.auth.id,
        store_turn_id: d.store_turn_id,
        payment_method_id: d.payment_method_id,
        description: d.description,
        name: d.name,
        nit: d.nit,
        phone: d.phone,
        email: d.email,
        items: d.items,
      })),
    }
    try {
      const response = await PosSrc.saveOfflineSells(_data)

      if (!response?.errors) await DBService.deleteAll('sells')
    } catch (err) {
      console.log(err)
    }
  }

  const onClose = () => {
    dispatch({ type: 'TURN' })
    props.status(false)
    setConfirmClose(false)
    SetStoreTurnList([])
    SetStoreTurn(null)
    setSelectedShop(null)
  }

  const onCancel = () => {
    if (confirmClose) {
      dispatch({ type: 'TURN' })
      props.status(false)
      setConfirmClose(false)
      SetStoreTurnList([])
      SetStoreTurn(null)
      setSelectedShop(null)
    } else {
      SetStoreTurnList([])
      setSelectedShop(null)
      SetStoreTurn(null)
      setConfirmClose(false)
      props.closable()
    }
  }

  const showTurnModal = async (key) => {
    const getStoreTurn = await PosSrc.getStoreTurn(storePos.id)
    setStoreTurnState(getStoreTurn)
    setTotal(key)
    setFlag(!flag)
  }

  const returnPrint = (key) => {
    switch (key) {
      case 1:
        return <TurnTicketFactura ref={componentRef} storeTurnState={storeTurnState} sellByNewMethods={sellByNewMethods} sold={sold} />
      default:
        break;
    }
  }

  const setSellByNewMethodsFunction = (value, index) => {
    let auxSellByNewMethods = sellByNewMethods
    auxSellByNewMethods[index - 4] = { 'payment_method_id': index, 'total_sold': value }
    setSellByNewMethods(auxSellByNewMethods)
  }

  function trunc(x, decimalDigits = 2, returnText = true, longFixed = true) {
    x = Number(x);
    decimalDigits = Number(decimalDigits);

    x = x * (10 ** decimalDigits);
    x = x - x % 1;
    x = x / (10 ** decimalDigits);

    if (returnText)
      if (longFixed)
        return x.toFixed(decimalDigits);
      else
        return x.toString();
    else
      return x;
  }

  return (
    <>
      <Drawer placement="right" closable={false} onClose={onCancel} visible={props.visible} width={800} className={'pos-drawer'}>
        <div style={{ display: 'none' }}>{returnPrint(total)}</div>
        <div>
          <Title> {!props.open ? 'Iniciar turno' : 'Cierre de turno'} </Title>
          <Divider className={'divider-custom-margins-users'} />
          {!props.open ? (
            <React.Fragment>
              <Row gutter={16} className={'section-space-list'}>
                <Col sm={24}>
                  <div className={'title-space-field pl-2'}>Nombre de tienda</div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <GenericSelect
                    disabled={loading}
                    loading={loading}
                    data={shopsList}
                    handlerChange={option => setSelectedShop(option)}
                    value={selectedShop}
                    placeholder={'Elige una tienda'}
                  />
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field title-space-top'}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>Efectivo en tienda</div>
                  <Input disabled={true} value={`${props.symbol} ${Utils.formatNumber(storeCash)}`} placeholder={'Efectivo en tienda'} size={'large'} />
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>Turno</div>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    disabled={storeTurnList?.length > 0 ? false : true}
                    loading={storeTurnList?.length > 0 ? false : true}
                    title={'Turno'}
                    value={storeTurn}
                    onChange={option => SetStoreTurn(option)}
                    placeholder={'Elige un turno'}
                    className={'single-select'}
                    size={'large'}
                    style={{ width: '100%' }}
                  >
                    {storeTurnList?.map(data => {
                      return (
                        <Option key={data.id} value={data.id}>
                          {`${data.start_time.slice(0, 5)} - ${data.end_time.slice(0, 5)}`}
                        </Option>
                      )
                    })}
                  </Select>
                </Col>
              </Row>
            </React.Fragment>
          ) : !confirmClose ? (
            <React.Fragment>
              <Row gutter={16} className={'section-space-list'}>
                <h4 className={'section-space-list-bottom pl-2'}>
                  {state.store.name} | {`${state.turnInfo.start_time.slice(0, 5)} - ${state.turnInfo.end_time.slice(0, 5)}`}
                </h4>
              </Row>
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿Cuánto hubo en gastos en efectivo que no fueron compras?</div>
                  <Input type="number" placeholder={'Escribe la cantidad'} onChange={e => setSpentCash(e.target.value)} size={'large'} />
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿De qué fueron esos gastos?</div>
                  <Input placeholder={'Escribe una breve explicacion'} onChange={e => setSpentCashInfo(e.target.value)} size={'large'} />
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'} align="bottom">
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿Cuánto vendiste en tarjeta?</div>
                  <Input type="number" placeholder={'Escribe la cantidad'} onChange={e => setSellByCard(e.target.value)} size={'large'} />
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿Cuánto efectivo tienes en mano al cerrar el turno?</div>
                  <Input type="number" placeholder={'Escribe la cantidad'} onChange={e => setCashAvailable(e.target.value)} size={'large'} />
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'} align="bottom">
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿Cuánto vendiste en servicios externos?</div>
                  <Input type="number" placeholder={'Escribe la cantidad'} onChange={e => setSellByeExternalServices(e.target.value)} size={'large'} />
                </Col>
              </Row>

              {paymentMethods?.map(data => {
                if (data.company_id === props.companyId) {
                  return (
                    <Row key={data.id} gutter={16} className={'section-space-field'} align="bottom">
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <div className={'title-space-field pl-2'}>{`¿Cuánto vendiste en ${data.description} ?`}</div>
                        <Input type="number" required placeholder={'Escribe la cantidad'} onChange={e => setSellByNewMethodsFunction(e.target.value, data.id)} size={'large'} />
                      </Col>
                    </Row>
                  )
                }
              })}

            </React.Fragment>
          ) : (
            <Row gutter={16}>
              <Col sm={11}>
                <h4 className={'section-space-list-bottom title-space-top'}>Cuadre en tarjeta</h4>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={18}>Venta en tarjeta según cierre</Col>
                  <Col sm={6} className={'total-quantity'}>
                    {props.symbol}. {trunc(sellByCard)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={18}>Venta en tarjeta según POS</Col>
                  <Col sm={6} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos.card_sales_pos)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col
                    offset={18}
                    sm={6}
                    className={trunc(sellByCard) === trunc(storePos.card_sales_pos) ? 'total-quantity isOk' : 'total-quantity isnotOk'}
                  >
                    {trunc(sellByCard) === trunc(storePos.card_sales_pos) ? 'Cuadrado' : 'No cuadra'}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={18}>Venta en servicios externos según cierre</Col>
                  <Col sm={6} className={'total-quantity'}>
                    {props.symbol}. {trunc(sellByeExternalServices)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={18}>Venta en servicios externos según registros</Col>
                  <Col sm={6} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos.services_sales)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col
                    offset={18}
                    sm={6}
                    className={trunc(sellByeExternalServices) === trunc(storePos.services_sales) ? 'total-quantity isOk' : 'total-quantity isnotOk'}
                  >
                    {trunc(sellByeExternalServices) === trunc(storePos.services_sales) ? 'Cuadrado' : 'No cuadra'}
                  </Col>
                </Row>

                {sold?.length > 0 && sellByNewMethods?.map(data => {
                  const found = paymentMethods.find(allMethod => allMethod.id === data.payment_method_id)

                  const foundSold = sold.find(method => method.id_payment_method === data.payment_method_id)

                  if (foundSold) {
                    return (
                      <>
                        <h4 className={'section-space-list-bottom title-space-top'}>{`Cuadre en ${found.description}`}</h4>
                        <Row gutter={16} className={'section-space-list-bottom'}>
                          <Col sm={18}>{`Venta en ${found.description} según cierre`}</Col>
                          <Col sm={6} className={'total-quantity'}>
                            {props.symbol}. {trunc(data.total_sold)}
                          </Col>
                        </Row>
                        <Row gutter={16} className={'section-space-list-bottom'}>
                          <Col sm={18}>{`Venta en ${found.description} según POS`}</Col>
                          <Col sm={6} className={'total-quantity'}>
                            {props.symbol}. {trunc(foundSold?.total_sold_with_payment_method)}
                          </Col>
                        </Row>
                        <Row gutter={16} className={'section-space-list-bottom'}>
                          <Col
                            offset={18}
                            sm={6}
                            className={trunc(data.total_sold) === trunc(foundSold.total_sold_with_payment_method) ? 'total-quantity isOk' : 'total-quantity isnotOk'}
                          >
                            {trunc(data.total_sold) === trunc(foundSold.total_sold_with_payment_method) ? 'Cuadrado' : 'No cuadra'}
                          </Col>
                        </Row>
                      </>
                    )
                  }
                })}
              </Col>

              <Col sm={1}>
                <div className="sell-divider"></div>
              </Col>
              <Col sm={12}>
                <h4 className={'section-space-list-bottom title-space-top'}>Cuadre en circulante</h4>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Turno empezó con</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos?.open_petty_cash_amount)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Gastado en compras</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos?.expenses_in_purchases)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Gastado en gastos (no compras)</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos?.expenses_in_not_purchases)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Depositado</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos?.deposits_total)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Vendido en efectivo</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos?.cash_sales)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Cobrado de cuentas por cobrar</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos?.cash_collected_in_receivables)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Ajustes realizados</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos?.cash_adjustments_total)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom final-section'}>
                  <Col offset={3} sm={13}>
                    Deberias tener
                  </Col>
                  <Col sm={8} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos?.closed_petty_cash_amount)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col offset={3} sm={13}>
                    Tienes en tienda
                  </Col>
                  <Col sm={8} className={'total-quantity'}>
                    {props.symbol}. {trunc(storePos?.cash_on_hand)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col
                    offset={16}
                    sm={8}
                    className={
                      trunc(storePos?.closed_petty_cash_amount) === trunc(storePos?.cash_on_hand) ? 'total-quantity isOk' : 'total-quantity isnotOk'
                    }
                  >
                    {trunc(storePos?.closed_petty_cash_amount) === trunc(storePos?.cash_on_hand) ? 'Cuadrado' : 'No cuadra'}
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </div>
        <div>
          <Divider className={'divider-custom-margins-users'} />
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <div className="text-right">
                <div>
                  {!confirmClose && (
                    <Button type={'link'} className="cancel-button" onClick={() => onCancel()}>
                      Cancelar
                    </Button>
                  )}
                  {!confirmClose ? (
                    <Button
                      loading={closeLoading}
                      htmlType="submit"
                      className="title-tendero new-button"
                      onClick={!props.open ? () => onStart(true) : () => onStart(false)}
                    >
                      {!props.open ? 'Iniciar' : 'Confirmar datos'}
                    </Button>
                  ) : (
                    <div className="next-button">
                      <Button onClick={() => showTurnModal(1)} style={{ marginRight: '1rem' }} className="title-tendero new-button" >
                        Imprimir turno
                      </Button>
                      <Button htmlType="submit" className="title-tendero new-button" onClick={onClose}>
                        Finalizar
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Drawer>
      <PosModalDeposit storeId={props.storeId} storeTurnId={openTurn?.id} visible={addDeposit} onClose={() => setAddDeposit(false)} />
    </>
  )
}

export default PosDrawer
